import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Input, Select, Autocomplete } from '~/components/Form';
import { t, validCharacters } from '~/helpers';
import {
  storeData,
  updateData,
} from '~/store/modules/inversorFrequencia/actions';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();

  const { client } = useSelector((state) => state.user.profile);
  const { loading, find, params } = useSelector(
    (state) => state.inversorFrequencia
  );

  const initials = create ? data : { ...find, ...data };

  const models = [{ label: 'WEG-CFW', value: 'WEG-CFW' }];

  const handleSubmit = useCallback(
    async (param) => {
      try {
        const schema = Yup.object().shape({
          idposto: create
            ? Yup.number().required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string(),
          idinversorfrequencia: Yup.number()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .integer(t('s.geral.validacao.inteiro')) // valor deve ser inteiro
            .min(1, t('s.geral.validacao.valorminimo').replace('%s', 1))
            .max(255, t('s.geral.validacao.valormaximo').replace('%s', 255)),
          modeloinversorfrequencia: Yup.string()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .required(t('s.geral.validacao.campoobrigatorio')),
          enderecoconversorinversorfrequencia: Yup.string()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .required(t('s.geral.validacao.campoobrigatorio'))
            .matches(
              /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/,
              t('s.geral.validacao.enderecoipinvalido') // Adapte a chave do i18n conforme sua estrutura
            ),
          portaconversorinversorfrequencia: Yup.number()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .integer(t('s.geral.validacao.inteiro')) // valor deve ser inteiro
            .min(1, t('s.geral.validacao.valorminimo').replace('%s', 1))
            .max(
              65535,
              t('s.geral.validacao.valormaximo').replace('%s', 65535)
            ),
        });

        await schema.validate(param, {
          abortEarly: false,
        });

        const objSend = {
          ...initials,
          ...param,
          idcliente: client,
        };

        if (create) {
          dispatch(storeData(objSend, params));
        } else {
          dispatch(updateData(objSend, params));
        }
      } catch (err) {
        const validationErrors = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            validationErrors[error.path] = error.message.replace(
              `${error.path} `,
              ''
            );
          });

          reference.current.setErrors(validationErrors);
        }
      }
    },
    [create, client, initials]
  );
  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          <Autocomplete
            name="idposto"
            label="codigonomeposto"
            url="postoscomboios"
            unique="idposto"
            title={t('s.geral.postocomboio')}
            disabled={!create}
          />
          <Input
            name="enderecoconversorinversorfrequencia"
            label={t('s.cadastro.preset.enderecopreset')}
            disabled={!create}
          />
          <Input
            name="idinversorfrequencia"
            label={t('s.menu.configuracao.inversoresfrequencias.enderecoRS485')}
            disabled={!create}
          />
          <Select
            name="modeloinversorfrequencia"
            variant="outlined"
            // size="small"
            label={t('s.menu.cadastro.veiculo.modelo')}
            options={models}
          />
          <Input
            name="portaconversorinversorfrequencia"
            label={t('s.configuracao.terminal.portaterminal')}
          />
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
